'use client';
import React, { useState } from 'react';
import { FaChevronDown } from 'react-icons/fa6';
import { IoSearchSharp } from 'react-icons/io5';

const ShopSidebarBrand = () => {
  const [isCollapsed, setIsCollapsed] = useState(false);
  const brand = [
    { id: 'fruits-check', label: 'Fruits', count: 34, checked: true },
    { id: 'fish-check', label: 'Fish', count: 24 },
    { id: 'vegetables-check', label: 'Vegetables', count: 80 },
    { id: 'meats-check', label: 'Meats', count: 5 },
    { id: 'oil-check', label: 'Oil', count: 12 },
    { id: 'milk-check', label: 'Milk', count: 12 },
    { id: 'frozen-check', label: 'Frozen', count: 64 },
  ];
  const handleClick = () => {
    setIsCollapsed((prev) => !prev);
  };

  return (
    <div
      className={`sidebar-filter sidebar-filter--brand sidebar-filter--collapsible mb-40 ${isCollapsed ? 'is-collapsed' : ''}`}
    >
      <div className="sidebar-filter__header">
        <h3 className="sidebar-filter__title">Brand</h3>
        <button
          onClick={handleClick}
          className="sidebar-filter__toggle btn btn-link p-0"
        >
          <FaChevronDown />
        </button>
      </div>

      <div id="brand-filter-content" className="sidebar-filter__content">
        <div className="sidebar-filter__search">
          <div className="input-group">
            <input
              type="text"
              className="form-control sidebar-filter__search-input"
              placeholder="Search"
            />
            <span className="input-group-text">
              <IoSearchSharp size={22} />
            </span>
          </div>
        </div>
        <ul className="sidebar-filter__list list-unstyled">
          {brand.map((item, i: number) => (
            <li key={i} className="sidebar-filter__item">
              <div className="form-check">
                <div className="check-group flex-grow-1">
                  <input
                    className="form-check-input"
                    type="checkbox"
                    id={item.id}
                    defaultChecked={item.checked}
                  />
                  <label className="form-check-label d-block" htmlFor={item.id}>
                    {item.label}
                  </label>
                </div>
                <span className="sidebar-filter__count">({item.count})</span>
              </div>
            </li>
          ))}
        </ul>
      </div>
    </div>
  );
};

export default ShopSidebarBrand;
